import { Box, styled } from '@pnld/components-web'

export const mapColors = {
  primary: '#23415B',
  selected: '#D27623',
  hover: '#1C3449',
  hoverSelected: '#A85E1C',
  stroke: '#475671',
}

const MapContainer = styled(Box, {
  baseStyle: {
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

const MapWrapper = styled(Box, {
  baseStyle: {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
})

export default {
  MapContainer,
  MapWrapper,
  mapColors,
}
